import { render, staticRenderFns } from "./Homepage.vue?vue&type=template&id=4c600e04&scoped=true&"
import script from "./Homepage.vue?vue&type=script&lang=js&"
export * from "./Homepage.vue?vue&type=script&lang=js&"
import style0 from "./Homepage.vue?vue&type=style&index=0&id=4c600e04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c600e04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c600e04')) {
      api.createRecord('4c600e04', component.options)
    } else {
      api.reload('4c600e04', component.options)
    }
    module.hot.accept("./Homepage.vue?vue&type=template&id=4c600e04&scoped=true&", function () {
      api.rerender('4c600e04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/Homepage.vue"
export default component.exports